import { en } from './languages/en';
import { ua } from './languages/ua';
import { ru } from './languages/ru';
import { es } from './languages/es';
import { de } from './languages/de';
import { no } from './languages/no';

export const translations = {
  en,
  ua,
  ru,
  es,
  de,
  no
};
